import { Route } from '@angular/router';
import { RequestComponent } from './request.component';

export const RequestRoutes: Route[] = [
  {
    path: 'req/:id',
    component: RequestComponent
  }
];
